<body>
  <div class="modal fade modalCenter" id="register">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content modal-sm">
        <div class="register-wrap">
          <div class="image">
            <img class="lazyload" data-src="../assets/images/section/login.jpg"
              src="../assets/images/section/login.jpg" alt="">
          </div>
          <div class="content">
            <div class="close-form">
              <a href="#" class="btn-hide-popup" data-bs-dismiss="modal" (click)="closeModal()"><i
                  class="icon-close"></i></a>
            </div>
            <h4 class="title">
              Open Your FREE Account
            </h4>

            <form id="form-register" class="form-register" [formGroup]="registerForm">
              <div class="cols mb-20">
                <fieldset>
                  <label for="field2">Your email</label>
                  <input id="field2" type="email" required placeholder="Your email" formControlName="emailAddress"
                    [class.is-invalid]="emailExists || registerForm.get('emailAddress')?.invalid">
                  <div *ngIf="registerForm.get('emailAddress')?.invalid && registerForm.get('emailAddress')?.touched"
                    class="invalid-feedback">
                    <div *ngIf="registerForm.get('emailAddress')?.errors?.['required']">Email is required</div>
                    <div *ngIf="registerForm.get('emailAddress')?.errors?.['email']">Invalid email format</div>
                  </div>
                </fieldset>
              </div>
              <div *ngIf="emailExists">
                <h6>This email address is already registered. Please use a different email.</h6><br />
              </div>

              <div class="cols mb-20 relative">
                <fieldset>
                  <label for="pass">Password</label>
                  <input class="password" id="pass1" [type]="isPasswordVisible ? 'text' : 'password'" required
                    placeholder="Password" formControlName="password">
                  <span class="toggle-password first-time" (click)="togglePasswordVisibility()"
                    (keydown)="togglePasswordVisibility()" tabindex="0" role="button">
                    <i class="icon-view"></i>
                  </span>
                </fieldset>
              </div>
              <h6>Min. 8 chars with 1 uppercase letter, 1 lowercase letter, 1 number and 1 symbol.</h6><br />
              <div class="cols mb-20 relative">
                <fieldset>
                  <label for="confirmPass1">Confirm password</label>
                  <input class="password" id="confirmPass1" [type]="isPasswordCVisible ? 'text' : 'password'" required
                    placeholder="Password" formControlName="confirmPassword">
                  <span class="toggle-password second-time" (click)="togglePasswordCVisibility()"
                    (keydown)="togglePasswordCVisibility()" tabindex="0" role="button">
                    <i class="icon-view "></i>
                  </span>
                </fieldset>
              </div>
              <div class="checkbox-item">
                <label class="mb-0">
                  <span class=""> I have read and accept the
                    <a routerLink="terms-and-conditions" class="notice type-secondary" (click)="closeModal()">
                      Terms of Use
                    </a>
                    and the
                    <a routerLink="privacy-policy" class="notice type-secondary" (click)="closeModal()">
                      Privacy Notice
                    </a>
                  </span>
                  <input type="checkbox" required formControlName="acceptedTermsAndCondition">
                  <span class="btn-checkbox"></span>
                </label>
              </div>

              <div *ngIf="registerForm.hasError('passwordMismatch')">
                <h6 style="color: #dc3545; font-weight: 500;  margin: 0;">The passwords doesn't match, please check them
                  before continue.</h6>
                <br>
              </div>

              <button type="button" class="btn-login tf-btn full-w"
                [ngClass]="{ 'style-1': registerForm.valid, 'style-3': !registerForm.valid }"
                [disabled]="registerForm.invalid" (click)="register()">
                Sign up
              </button>
            </form>

            <p class="bottom-form">
              Already registered?
              <a href="javascript:void(0);" class="type-main-color" (click)="openLoginModal()">
                Click here
              </a>
              to login.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>